[].slice.call(document.getElementsByClassName("dl-accordion")).map(function (dlElement, index) {
	dlElement.id = "accordion" + index;
	[].slice.call(dlElement.getElementsByTagName("dd")).map(function (ddElement, index) {
		var dtElement = ddElement.previousElementSibling;
		ddElement.id = dlElement.id + "_" + index;
		ddElement.dataset.bsParent = "#" + dlElement.id;
		ddElement.classList.add("collapse");
		ddElement.classList.add("m-3");
		dtElement.dataset.bsTarget = "#" + ddElement.id;
		dtElement.dataset.bsToggle = "collapse";
		dtElement.classList.add("btn-link");
		dtElement.classList.add("my-3");
		dtElement.classList.add("mx-0");
	});
});
